export default "__VITE_ASSET__618ae4db__"